import { useCallback, useMemo } from "react"
import { CORE_STEP_NAMES } from "../models/enum/rsvpEnum"

const useStepNavigation = (stepPipeline: string[], currentStepName: string, setStep: (name: string) => void) => {
  const currentIndex = useMemo(
    () => stepPipeline.indexOf(currentStepName),
    [stepPipeline, currentStepName],
  )

  const isFirst = useMemo(() => currentIndex === 0, [currentIndex])

  const isLast = useMemo(
    () => currentIndex === stepPipeline.length - 1,
    [currentIndex, stepPipeline.length],
  )

  const goNext = useCallback(() => {
    if (currentIndex < 0 || currentIndex >= stepPipeline.length - 1) {
      return
    }

    setStep(stepPipeline[currentIndex + 1])
  }, [currentIndex, setStep, stepPipeline])

  const goPrevious = useCallback(() => {
    if (currentIndex <= 0) {
      return
    }

    setStep(stepPipeline[currentIndex - 1])
  }, [currentIndex, setStep, stepPipeline])

  const goTo = useCallback(
    (name: string) => {
      if (!stepPipeline.includes(name)) {
        return
      }

      setStep(name)
    },
    [setStep, stepPipeline],
  )

  const goToSummary = useCallback(() => {
    if (stepPipeline.includes(CORE_STEP_NAMES.SUMMARY)) {
      setStep(CORE_STEP_NAMES.SUMMARY)
      return
    }

    goNext()
  }, [goNext, setStep, stepPipeline])

  return {
    goNext,
    goPrevious,
    goTo,
    goToSummary,
    isFirst,
    isLast,
    currentIndex,
  }
}

export default useStepNavigation
